import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-contract-type-anagraf',
  templateUrl: './new-contract-type-anagraf.component.html',
  styleUrls: ['./new-contract-type-anagraf.component.scss']
})
export class NewContractTypeAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  contractType: ContractTypeModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  submitted = false;
  constructor(private route: ActivatedRoute, private router: Router,
              private contractTypeService: ContractTypeService) {
    super();

    this.contractType = new ContractTypeModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.contractType.cod, [Validators.required]],
      description: [this.contractType.description, [Validators.required]],
      startNumAnnoMese: [this.contractType.startNumAnnoMese, [Validators.required]],
      endNumAnnoMese: [this.contractType.endNumAnnoMese, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.CONTRACT_TYPE_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    this.submitted = true;
    let startYearMonth = null;
    let endYearMonth = null;
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      startYearMonth = new Date(this.formValidator.value.startNumAnnoMese);
      endYearMonth = new Date(this.formValidator.value.endNumAnnoMese);
      const startYearMonthFinal = startYearMonth.getFullYear() + ('0' + (startYearMonth.getMonth() + 1)).slice(-2);
      const endYearMonthFinal = endYearMonth.getFullYear() + ('0' + (endYearMonth.getMonth() + 1)).slice(-2);
      if ( startYearMonthFinal <= endYearMonthFinal) {
        this.contractType.cod = this.formValidator.value.cod;
        this.contractType.description = this.formValidator.value.description;
        this.contractType.startNumAnnoMese = startYearMonthFinal;
        this.contractType.endNumAnnoMese = endYearMonthFinal;
        this.saveSubscribe = this.contractTypeService.save(this.contractTypeService.baseUrl, this.contractType).subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, Contract Type cod already exists', 'Warning');
            } else {
              toastr.success('Contract Type was added with success', 'Success');
              this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.CONTRACT_TYPE_ANAGRF]);
            }
          });

      } else {
        toastr.warning('Please check Dates before continue', 'Warning');
      }
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get fv() { return this.formValidator.controls; }


}
